import { application } from "./application"

import CertificateDesignerController from "./certificate_designer_controller"
application.register("certificate-designer", CertificateDesignerController)

import CertificatePickerController from "./certificate_picker_controller"
application.register("certificate-picker", CertificatePickerController)

import CertificateThumbnailController from "./certificate_thumbnail_controller"
application.register("certificate-thumbnail", CertificateThumbnailController)

import CheckboxGroupController from "./checkbox_group_controller"
application.register("checkbox-group", CheckboxGroupController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ColorSyncController from "./color_sync_controller"
application.register("color-sync", ColorSyncController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import CountryFieldController from "./country_field_controller"
application.register("country-field", CountryFieldController)

import CsvImportController from "./csv_import_controller"
application.register("csv-import", CsvImportController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DateRangeFieldController from "./date_range_field_controller"
application.register("date-range-field", DateRangeFieldController)

import DateRangePickerController from "./date_range_picker_controller"
application.register("date-range-picker", DateRangePickerController)

import DirtyFormController from "./dirty_form_controller"
application.register("dirty-form", DirtyFormController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ImpersonationBarController from "./impersonation_bar_controller"
application.register("impersonation-bar", ImpersonationBarController)

import EditingClaimController from "./editing_claim_controller"
application.register("editing-claim", EditingClaimController)

import EmailPreviewController from "./email_preview_controller"
application.register("email-preview", EmailPreviewController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import IframeResizeController from "./iframe_resize_controller"
application.register("iframe-resize", IframeResizeController)

import ListFilterController from "./list_filter_controller"
application.register("list-filter", ListFilterController)

import LogoPreviewController from "./logo_preview_controller"
application.register("logo-preview", LogoPreviewController)

import NewsletterEditorController from "./newsletter_editor_controller"
application.register("newsletter-editor", NewsletterEditorController)

import NewsletterSendController from "./newsletter_send_controller"
application.register("newsletter-send", NewsletterSendController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import QuestionFormController from "./question_form_controller"
application.register("question-form", QuestionFormController)

import QuestionnaireFormController from "./questionnaire_form_controller"
application.register("questionnaire-form", QuestionnaireFormController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import RichTextController from "./rich_text_controller"
application.register("rich-text", RichTextController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TravellerLookupController from "./traveller_lookup_controller"
application.register("traveller-lookup", TravellerLookupController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)
